<div class="brand-logos-wrap">
  <app-brand-logo *ngFor="let brand of brands" [brand]="brand"></app-brand-logo>
  <span 
    matBadge="{{ ( blengths > 3 ) ? ('+' + (blengths - 3)) : null }}" 
    matBadgeOverlap="false"
    matBadgeSize="small" 
    matBadgePosition="after"></span>
</div>